/**
 * Veroni header condense-on-scroll.
 * Additive to Horizon's native sticky header (settings.enable_sticky_header).
 * Toggles [data-condensed="true"] on #header-component once the page has
 * scrolled past a small threshold; veroni-theme.css uses that attribute to
 * shrink padding/logo. Does not replace or fight Horizon's own
 * data-scroll-direction / data-sticky-state plumbing in header.js.
 */
(function () {
  var THRESHOLD = 60;
  var header = null;
  var ticking = false;

  function applyState() {
    ticking = false;
    if (!header) return;
    var condensed = window.scrollY > THRESHOLD;
    header.setAttribute('data-condensed', condensed ? 'true' : 'false');
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(applyState);
      ticking = true;
    }
  }

  function init() {
    header = document.getElementById('header-component');
    if (!header) return;
    applyState();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
